import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '../../reactQuery';
import { fetchAccountVehicles, fetchOneAccountVehicle, postAccountVehicles, putAccountVehicles } from './api';
export const useOneAccountVehicle = (accountVehicleId, t0, options) => {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const queryParams = t1;
  let t2;
  let t3;
  if ($[2] !== accountVehicleId || $[3] !== queryParams) {
    t2 = ["account-vehicle", accountVehicleId, queryParams];
    t3 = async () => fetchOneAccountVehicle(accountVehicleId, queryParams);
    $[2] = accountVehicleId;
    $[3] = queryParams;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== options || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      ...options
    };
    $[6] = options;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return useQuery(t4);
};
export const useAccountVehicles = (queryParams, options) => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] !== queryParams) {
    t0 = ["account-vehicles", queryParams];
    t1 = async () => fetchAccountVehicles(queryParams);
    $[0] = queryParams;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1,
      ...options
    };
    $[3] = options;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return useQuery(t2);
};
export const usePostAccountVehicles = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = {
      mutationFn: _temp,
      ...options
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export const usePutAccountVehicles = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = {
      mutationFn: _temp2,
      ...options
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
function _temp(body) {
  return postAccountVehicles(body);
}
function _temp2(body) {
  return putAccountVehicles(body);
}